import "./Loader.css";

const Loader = () => {
  return (
    <div className="mainDiv loding-animation">
      <div className="parentDiv">
        <div className="childDiv">
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
